module.exports = __webpack_public_path__ + "img/shiyanxiang.1f5a91ac.jpg";